import React from 'react';
import { Spin } from 'antd';
import InfoCard from '../InfoCard/InfoCard';
import DropdownButton from '../DropdownButton/DropdownButton';
import { CardChangeButton } from '../../../../../components/Card';
import styles from './Stages.module.scss';

const Stages = ({
  loading = false,
  title,
  stages,
  onMenuClick,
  selectedKeys,
  stageName,
  type,
  stageMassAction,
}) => {
  return (
    <InfoCard
      title={title}
      action={
        typeof onMenuClick === 'function' ? (
          <DropdownButton
            disabled={loading}
            menuItems={stages}
            trigger={['click']}
            onMenuClick={onMenuClick}
            menuProps={{ selectable: true, selectedKeys: selectedKeys }}
            stageMassAction={stageMassAction}
          >
            <CardChangeButton />
          </DropdownButton>
        ) : undefined
      }
      className={type === 'life' ? styles.wrapperLife : styles.wrapper}
    >
      <Spin spinning={loading}>
        <p className={styles.content}>{stageName}</p>
      </Spin>
    </InfoCard>
  );
};

export default Stages;
